import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class FaqVideosComponent implements OnInit {

  panelOpenState = false;
  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('videos').subscribe(result => {
      this.faq = result;
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    });
  }
}
